var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEggEmpty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.82449 7.64062L4.00097 7.6431L4.68648 7.92259L8.25992 11.3779L9.87058 9.94231L11.2142 9.9706L12.6428 11.3536L14.0739 9.97009L15.4465 9.96959L16.8812 11.3545L18.3133 9.97009L19.6864 11.4589L17.5682 13.5065L16.1957 13.507L14.761 12.1221L13.3288 13.5065L11.9552 13.506L10.4994 12.0967L8.88918 13.5319L7.54595 13.504L3.60181 9.69027L1.82227 9.68825L1.82449 7.64062Z",
    fill: "#3360AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 21.4644C9 22.3126 8.32843 23.0001 7.5 23.0001C6.67157 23.0001 6 22.3126 6 21.4644C6 20.6163 6.67157 19.9287 7.5 19.9287C8.32843 19.9287 9 20.6163 9 21.4644Z",
    fill: "#208C72"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.999 21.4644C18.999 22.3126 18.3275 23.0001 17.499 23.0001C16.6706 23.0001 15.999 22.3126 15.999 21.4644C15.999 20.6163 16.6706 19.9287 17.499 19.9287C18.3275 19.9287 18.999 20.6163 18.999 21.4644Z",
    fill: "#EA1763"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.10491 6.28794C7.96998 8.05588 7.1613 10.4279 7.0203 12.7621C6.88181 15.0549 7.49297 16.5425 8.42071 17.4651C9.36585 18.4051 10.7862 18.9048 12.5283 18.9048C14.2708 18.9048 15.6837 18.4049 16.6176 17.4682C17.5339 16.5491 18.1331 15.0644 17.976 12.7705C17.8139 10.4025 17.0907 8.0175 16.0552 6.25289C14.9874 4.43314 13.7664 3.54762 12.699 3.54762C11.6064 3.54762 10.275 4.46525 9.10491 6.28794ZM7.43358 5.16331C8.72243 3.15561 10.5775 1.5 12.699 1.5C14.8455 1.5 16.5897 3.18772 17.7696 5.19837C18.9819 7.26416 19.789 9.96669 19.9711 12.6274C20.1584 15.3621 19.4514 17.4923 18.0173 18.9308C18.0092 18.9389 18.0011 18.947 17.993 18.955C17.8336 18.9224 17.6688 18.9053 17.5 18.9053C16.4171 18.9053 15.4951 19.6101 15.1476 20.5962C14.3197 20.8396 13.4342 20.9524 12.5283 20.9524C11.6004 20.9524 10.6935 20.8341 9.84708 20.5786C9.49495 19.6018 8.57741 18.9053 7.50098 18.9053C7.34411 18.9053 7.19062 18.9201 7.04176 18.9484L7.02717 18.9339C5.5842 17.4989 4.85886 15.3717 5.02412 12.6357C5.18687 9.94127 6.10958 7.22577 7.43358 5.16331Z",
    fill: "#3360AD"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEggEmpty);
export default __webpack_public_path__ + "static/media/egg-empty.ddaac5a551d148092a3a123877e0eecc.svg";
export { ForwardRef as ReactComponent };